<template>
  <b-card class="text-center">
    <p>¿Has tomado anteriormente alguna especialidad o diplomado impartido por nosotros?</p>

    <!-- Botones (sí - no) -->
    <div class="option-container">
      <b-button
        :variant="`${selectedOption === true ? '' : 'outline-'}primary`"
        @click="handleOnSelectedChoice(true)"
      >
        <feather-icon
          icon="CheckIcon"
          class="mr-50"
        />
        Sí
      </b-button>

      <b-button
        :variant="`${selectedOption === false ? '' : 'outline-'}danger`"
        @click="handleOnSelectedChoice(false)"
      >
        <feather-icon
          icon="XIcon"
          class="mr-50"
        />
        No
      </b-button>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BButton,
  },
  setup(_, { emit }) {
    const selectedOption = ref(null)

    // Función que gestiona el cambio de opción (sí | no)
    const handleOnSelectedChoice = choice => {
      selectedOption.value = choice
      emit('choice-selected', choice)
    }

    return {
      selectedOption,
      handleOnSelectedChoice,
    }
  },
}
</script>

<style scoped>
.option-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;

  button {
    width: 100%;
  }
}
</style>
